<template>
   <div id="app" ref="app">
    <el-container>
      <el-header height="0">
        <NavBar/>
        <MobileNavBar/>
      </el-header>
      <el-main style="padding: 0;">
        <SideTool/>
        <router-view />
      </el-main>
      <el-footer style="padding: 0;">
        <CallMe/>
        <MobileCallMe/>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
  import CallMe from '@/components/call-me/index.vue'
  import MobileCallMe from '@/components/call-me/MobileCallMe.vue'
  import NavBar from '@/components/nav-bar/index.vue'
  import MobileNavBar from '@/components/nav-bar/MobileNavBar.vue'
  import SideTool from '@/components/SideTool.vue'

  export default {
    components: { NavBar, MobileCallMe, MobileNavBar, CallMe, SideTool },
    watch: {
      $route() {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
      },
    },
  }
</script>

<style scoped>

</style>
